import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useCliente } from "../context/ClienteContext";

const ListagemSessoesAulaAgrupada = () => {
  const [sessoes, setSessoes] = useState([]);
  const [filtroNome, setFiltroNome] = useState("");
  const navigate = useNavigate();
  const { parametros } = useCliente();
  const professorId = localStorage.getItem("user_id");

  useEffect(() => {
    const carregarSessoes = async () => {
      try {
        const response = await axios.get(`/api/sessoes_aula/professor/${professorId}`);
        setSessoes(response.data);
      } catch (error) {
        console.error("Erro ao carregar sessões:", error);
      }
    };

    carregarSessoes();
  }, [professorId]);

  // Agrupar sessões por disciplina
  const sessoesAgrupadas = {};
  sessoes.forEach(sessao => {
    sessao.disciplinas.forEach(disciplina => {
      if (!sessoesAgrupadas[disciplina.nome]) {
        sessoesAgrupadas[disciplina.nome] = [];
      }
      if (sessao.nome.toLowerCase().includes(filtroNome.toLowerCase())) {
        sessoesAgrupadas[disciplina.nome].push({
          id: sessao.id,
          nome: sessao.nome,
          criado_em: sessao.criado_em,
          atualizado_em: sessao.atualizado_em
        });
      }
    });
  });

  return (
    <div className="form-wrapper">
      <h2 className="form-title">Minhas Sessões de Aula</h2>

      <div className="form-actions" style={{
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "16px",
        gap: "12px",
        flexWrap: "wrap"
      }}>
        <input
          type="text"
          value={filtroNome}
          onChange={(e) => setFiltroNome(e.target.value)}
          placeholder="Filtrar por nome da sessão"
          style={{ flex: 1, minWidth: "200px" }}
        />
        <button className="btn btn-primary" onClick={() => navigate("/cadastro-sessao")}>
          Cadastrar Sessão
        </button>
      </div>

      {Object.keys(sessoesAgrupadas).length > 0 ? (
        Object.entries(sessoesAgrupadas).map(([disciplina, lista]) => (
          <div key={disciplina} style={{ marginBottom: "24px" }}>
            <h3 style={{ marginBottom: "10px" }}>{disciplina}</h3>
            <table className="tabela">
              <thead style={{
                backgroundColor: parametros?.cor_cabecalho || "#156082",
                color: "white"
              }}>
                <tr>
                  <th>Nome da Sessão</th>
                  <th style={{ width: "175px", whiteSpace: "nowrap" }}>Última atualização</th>
                </tr>
              </thead>
              <tbody>
                {lista.map(sessao => (
                  <tr key={`${disciplina}-${sessao.id}`}>
                    <td>
                      <Link to={`/sessao/${sessao.id}`} style={{ color: "#156082", textDecoration: "underline" }}>
                        {sessao.nome}
                      </Link>
                    </td>
                    <td style={{ width: "175px", whiteSpace: "nowrap" }}>
                       {sessao.atualizado_em || sessao.criado_em}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))
      ) : (
        <p>Nenhuma sessão encontrada com esse filtro.</p>
      )}
    
{/* Listagem de sessões sem disciplina (somente ao final) */}
{(() => {
  const sessoesSemDisciplina = sessoes.filter(sessao =>
    sessao.disciplinas.length === 0 &&
    sessao.nome.toLowerCase().includes(filtroNome.toLowerCase())
  );

  if (sessoesSemDisciplina.length === 0) return null;

  return (
    <div style={{ marginTop: "40px" }}>
      <h3 style={{ marginBottom: "10px" }}>Sessões sem disciplina vinculada</h3>
      <table className="tabela">
        <thead style={{
          backgroundColor: parametros?.cor_cabecalho || "#156082",
          color: "white"
        }}>
          <tr>
            <th>Nome da Sessão</th>
            <th style={{ width: "175px", whiteSpace: "nowrap" }}>Última atualização</th>
          </tr>
        </thead>
        <tbody>
          {sessoesSemDisciplina.map(sessao => (
            <tr key={`sem-disciplina-${sessao.id}`}>
              <td>
                <Link to={`/sessao/${sessao.id}`} style={{ color: "#156082", textDecoration: "underline" }}>
                  {sessao.nome}
                </Link>
              </td>
              <td style={{ width: "175px", whiteSpace: "nowrap" }}>
                {sessao.atualizado_em || sessao.criado_em}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
})()}
</div>
  );
};

export default ListagemSessoesAulaAgrupada;
